/**
 * Handicap match-card demos for the marketing pages — generated from the real
 * resolver (POST api/v2/handicapschemes/preview) for each sport's default scheme,
 * so the on-page HandicapMatchBanner is pixel- and word-true to the app.
 * Regenerate after changing HandicapSchemeCatalog / HandicapStartResolver.
 * Keys are the catalog's sport names; `handicapPairsDemo` is an americano doubles pairing.
 */
export const handicapStartDemos = {
  "Snooker": {
    "schemeKey": "snooker-frame-points",
    "schemeLabel": "Points start per frame",
    "start": {
      "homeLabel": "−10",
      "awayLabel": "+20",
      "homeStart": 0,
      "awayStart": 30,
      "summary": "Alex M. starts each frame 30–0 up",
      "isLevel": false,
      "scoreboard": {
        "unit": "frame",
        "starts": [
          0,
          30
        ],
        "display": [
          "0",
          "30"
        ]
      },
      "home": {
        "name": "Dana R.",
        "label": "−10",
        "sign": -1,
        "players": [],
        "startText": "Each frame starts at 0",
        "boardDisplay": "0",
        "tiebreaks": []
      },
      "away": {
        "name": "Alex M.",
        "label": "+20",
        "sign": 1,
        "players": [],
        "startText": "Starts each frame 30–0 up",
        "boardDisplay": "30",
        "tiebreaks": []
      },
      "played": false,
      "tiebreakMode": 1,
      "tiebreaks": [],
      "entryHint": {
        "unit": "frame",
        "starts": [
          0,
          30
        ],
        "allowNegative": false,
        "note": "Enter scores as played, start included."
      }
    }
  },
  "Pool": {
    "schemeKey": "pool-frames-start",
    "schemeLabel": "Frames start",
    "start": {
      "homeLabel": "0 frames",
      "awayLabel": "2 frames",
      "homeStart": 0,
      "awayStart": 2,
      "summary": "Alex M. starts the match 2 frames up",
      "isLevel": false,
      "scoreboard": {
        "unit": "match",
        "starts": [
          0,
          2
        ],
        "display": [
          "0",
          "2"
        ]
      },
      "home": {
        "name": "Dana R.",
        "label": "0 frames",
        "sign": 0,
        "players": [],
        "startText": "Level",
        "boardDisplay": "0",
        "tiebreaks": []
      },
      "away": {
        "name": "Alex M.",
        "label": "2 frames",
        "sign": 1,
        "players": [],
        "startText": "Starts the match 2 frames up",
        "boardDisplay": "2",
        "tiebreaks": []
      },
      "played": false,
      "tiebreakMode": 1,
      "tiebreaks": [],
      "entryHint": {
        "unit": "match",
        "starts": [
          0,
          2
        ],
        "allowNegative": false,
        "note": "Enter scores as played, start included."
      }
    }
  },
  "Darts": {
    "schemeKey": "darts-start-reduction",
    "schemeLabel": "Points off the starting score",
    "start": {
      "homeLabel": "0 points",
      "awayLabel": "30 points",
      "homeStart": 0,
      "awayStart": 30,
      "summary": "Alex M. starts each leg on 471",
      "isLevel": false,
      "scoreboard": {
        "unit": "leg",
        "starts": [
          501,
          471
        ],
        "display": [
          "501",
          "471"
        ]
      },
      "home": {
        "name": "Dana R.",
        "label": "0 points",
        "sign": 0,
        "players": [],
        "startText": "Starts each leg on 501",
        "boardDisplay": "501",
        "tiebreaks": []
      },
      "away": {
        "name": "Alex M.",
        "label": "30 points",
        "sign": 1,
        "players": [],
        "startText": "Starts each leg on 471",
        "boardDisplay": "471",
        "tiebreaks": []
      },
      "played": false,
      "tiebreakMode": 1,
      "tiebreaks": []
    }
  },
  "Bowls": {
    "schemeKey": "bowls-shots",
    "schemeLabel": "Shots",
    "start": {
      "homeLabel": "1 shot",
      "awayLabel": "6 shots",
      "homeStart": 0,
      "awayStart": 5,
      "summary": "Alex M. starts the match 5–0 up",
      "isLevel": false,
      "scoreboard": {
        "unit": "match",
        "starts": [
          0,
          5
        ],
        "display": [
          "0",
          "5"
        ]
      },
      "home": {
        "name": "Dana R.",
        "label": "1 shot",
        "sign": 1,
        "players": [],
        "startText": "The match starts at 0",
        "boardDisplay": "0",
        "tiebreaks": []
      },
      "away": {
        "name": "Alex M.",
        "label": "6 shots",
        "sign": 1,
        "players": [],
        "startText": "Starts the match 5–0 up",
        "boardDisplay": "5",
        "tiebreaks": []
      },
      "played": false,
      "tiebreakMode": 1,
      "tiebreaks": []
    }
  },
  "Table Tennis": {
    "schemeKey": "tabletennis-game-points",
    "schemeLabel": "Points start per game",
    "start": {
      "homeLabel": "0",
      "awayLabel": "+4",
      "homeStart": 0,
      "awayStart": 4,
      "summary": "Alex M. starts each game 4–0 up",
      "isLevel": false,
      "scoreboard": {
        "unit": "game",
        "starts": [
          0,
          4
        ],
        "display": [
          "0",
          "4"
        ]
      },
      "home": {
        "name": "Dana R.",
        "label": "0",
        "sign": 0,
        "players": [],
        "startText": "Each game starts at 0",
        "boardDisplay": "0",
        "tiebreaks": []
      },
      "away": {
        "name": "Alex M.",
        "label": "+4",
        "sign": 1,
        "players": [],
        "startText": "Starts each game 4–0 up",
        "boardDisplay": "4",
        "tiebreaks": []
      },
      "played": false,
      "tiebreakMode": 1,
      "tiebreaks": [],
      "entryHint": {
        "unit": "game",
        "starts": [
          0,
          4
        ],
        "allowNegative": false,
        "note": "Enter scores as played, start included."
      }
    }
  },
  "Squash": {
    "schemeKey": "squash-game-points",
    "schemeLabel": "Points start per game",
    "start": {
      "homeLabel": "−2",
      "awayLabel": "+6",
      "homeStart": -2,
      "awayStart": 6,
      "summary": "Dana R. starts at −2 and Alex M. starts 6–0 up each game",
      "isLevel": false,
      "scoreboard": {
        "unit": "game",
        "starts": [
          -2,
          6
        ],
        "display": [
          "−2",
          "6"
        ]
      },
      "home": {
        "name": "Dana R.",
        "label": "−2",
        "sign": -1,
        "players": [],
        "startText": "Starts each game at −2",
        "boardDisplay": "−2",
        "tiebreaks": []
      },
      "away": {
        "name": "Alex M.",
        "label": "+6",
        "sign": 1,
        "players": [],
        "startText": "Starts each game 6–0 up",
        "boardDisplay": "6",
        "tiebreaks": []
      },
      "played": false,
      "tiebreakMode": 1,
      "tiebreaks": [],
      "entryHint": {
        "unit": "game",
        "starts": [
          -2,
          6
        ],
        "allowNegative": true,
        "note": "Enter scores as played, start included. A side starting below zero can finish on a negative score."
      }
    }
  },
  "Racketball": {
    "schemeKey": "racketball-game-points",
    "schemeLabel": "Points start per game",
    "start": {
      "homeLabel": "0",
      "awayLabel": "+5",
      "homeStart": 0,
      "awayStart": 5,
      "summary": "Alex M. starts each game 5–0 up",
      "isLevel": false,
      "scoreboard": {
        "unit": "game",
        "starts": [
          0,
          5
        ],
        "display": [
          "0",
          "5"
        ]
      },
      "home": {
        "name": "Dana R.",
        "label": "0",
        "sign": 0,
        "players": [],
        "startText": "Each game starts at 0",
        "boardDisplay": "0",
        "tiebreaks": []
      },
      "away": {
        "name": "Alex M.",
        "label": "+5",
        "sign": 1,
        "players": [],
        "startText": "Starts each game 5–0 up",
        "boardDisplay": "5",
        "tiebreaks": []
      },
      "played": false,
      "tiebreakMode": 1,
      "tiebreaks": [],
      "entryHint": {
        "unit": "game",
        "starts": [
          0,
          5
        ],
        "allowNegative": false,
        "note": "Enter scores as played, start included."
      }
    }
  },
  "Badminton": {
    "schemeKey": "badminton-game-points",
    "schemeLabel": "Points start per game",
    "start": {
      "homeLabel": "0",
      "awayLabel": "+5",
      "homeStart": 0,
      "awayStart": 5,
      "summary": "Alex M. starts each game 5–0 up",
      "isLevel": false,
      "scoreboard": {
        "unit": "game",
        "starts": [
          0,
          5
        ],
        "display": [
          "0",
          "5"
        ]
      },
      "home": {
        "name": "Dana R.",
        "label": "0",
        "sign": 0,
        "players": [],
        "startText": "Each game starts at 0",
        "boardDisplay": "0",
        "tiebreaks": []
      },
      "away": {
        "name": "Alex M.",
        "label": "+5",
        "sign": 1,
        "players": [],
        "startText": "Starts each game 5–0 up",
        "boardDisplay": "5",
        "tiebreaks": []
      },
      "played": false,
      "tiebreakMode": 1,
      "tiebreaks": [],
      "entryHint": {
        "unit": "game",
        "starts": [
          0,
          5
        ],
        "allowNegative": false,
        "note": "Enter scores as played, start included."
      }
    }
  },
  "Pickleball": {
    "schemeKey": "pickleball-game-points",
    "schemeLabel": "Points start per game",
    "start": {
      "homeLabel": "0",
      "awayLabel": "+3",
      "homeStart": 0,
      "awayStart": 3,
      "summary": "Alex M. starts each game 3–0 up",
      "isLevel": false,
      "scoreboard": {
        "unit": "game",
        "starts": [
          0,
          3
        ],
        "display": [
          "0",
          "3"
        ]
      },
      "home": {
        "name": "Dana R.",
        "label": "0",
        "sign": 0,
        "players": [],
        "startText": "Each game starts at 0",
        "boardDisplay": "0",
        "tiebreaks": []
      },
      "away": {
        "name": "Alex M.",
        "label": "+3",
        "sign": 1,
        "players": [],
        "startText": "Starts each game 3–0 up",
        "boardDisplay": "3",
        "tiebreaks": []
      },
      "played": false,
      "tiebreakMode": 1,
      "tiebreaks": [],
      "entryHint": {
        "unit": "game",
        "starts": [
          0,
          3
        ],
        "allowNegative": false,
        "note": "Enter scores as played, start included."
      }
    }
  },
  "Tennis": {
    "schemeKey": "tennis-fifteens",
    "schemeLabel": "Owe / receive (15, 30, 40)",
    "start": {
      "homeLabel": "Owe 15",
      "awayLabel": "Receive 15.3",
      "homeStart": -1,
      "awayStart": 1.3,
      "summary": "Dana R. owes 15 and Alex M. receives 15.3 each game",
      "isLevel": false,
      "scoreboard": {
        "unit": "game",
        "starts": [
          -1,
          1
        ],
        "display": [
          "Owe 15",
          "15"
        ],
        "sixGamePattern": [
          "Owe 15–15",
          "Owe 15–30",
          "Owe 15–15",
          "Owe 15–30",
          "Owe 15–15",
          "Owe 15–30"
        ]
      },
      "home": {
        "name": "Dana R.",
        "label": "Owe 15",
        "sign": -1,
        "players": [],
        "startText": "Each game starts at Owe 15",
        "boardDisplay": "Owe 15",
        "tiebreaks": [
          {
            "unit": "tiebreakGame",
            "label": "7-point tie-break",
            "target": 7,
            "start": -2,
            "text": "Starts at −2"
          },
          {
            "unit": "championsTiebreak",
            "label": "Match tie-break to 10",
            "target": 10,
            "start": -3,
            "text": "Starts at −3"
          }
        ]
      },
      "away": {
        "name": "Alex M.",
        "label": "Receive 15.3",
        "sign": 1,
        "players": [],
        "startText": "Each game starts at 15",
        "boardDisplay": "15",
        "patternNote": "At 30 in games 2, 4, 6 of every 6",
        "tiebreaks": [
          {
            "unit": "tiebreakGame",
            "label": "7-point tie-break",
            "target": 7,
            "start": 2,
            "text": "Starts 2–0 up"
          },
          {
            "unit": "championsTiebreak",
            "label": "Match tie-break to 10",
            "target": 10,
            "start": 3,
            "text": "Starts 3–0 up"
          }
        ]
      },
      "played": false,
      "tiebreakMode": 1,
      "tiebreaks": [
        {
          "unit": "tiebreakGame",
          "label": "7-point tie-break",
          "target": 7,
          "starts": [
            -2,
            2
          ],
          "display": "(−2)–2"
        },
        {
          "unit": "championsTiebreak",
          "label": "Match tie-break to 10",
          "target": 10,
          "starts": [
            -3,
            3
          ],
          "display": "(−3)–3"
        }
      ]
    }
  },
  "Padel": {
    "schemeKey": "padel-fifteens",
    "schemeLabel": "Owe / receive (15, 30, 40)",
    "start": {
      "homeLabel": "Scratch",
      "awayLabel": "Receive 15.2",
      "homeStart": 0,
      "awayStart": 1.2,
      "summary": "Alex M. receives 15.2 each game",
      "isLevel": false,
      "scoreboard": {
        "unit": "game",
        "starts": [
          0,
          1
        ],
        "display": [
          "0",
          "15"
        ],
        "sixGamePattern": [
          "0–15",
          "0–30",
          "0–15",
          "0–30",
          "0–15",
          "0–15"
        ]
      },
      "home": {
        "name": "Dana R.",
        "label": "Scratch",
        "sign": 0,
        "players": [],
        "startText": "Scratch",
        "boardDisplay": "0",
        "tiebreaks": [
          {
            "unit": "tiebreakGame",
            "label": "7-point tie-break",
            "target": 7,
            "start": 0,
            "text": "Level"
          },
          {
            "unit": "championsTiebreak",
            "label": "Match tie-break to 10",
            "target": 10,
            "start": 0,
            "text": "Level"
          }
        ]
      },
      "away": {
        "name": "Alex M.",
        "label": "Receive 15.2",
        "sign": 1,
        "players": [],
        "startText": "Each game starts at 15",
        "boardDisplay": "15",
        "patternNote": "At 30 in games 2, 4 of every 6",
        "tiebreaks": [
          {
            "unit": "tiebreakGame",
            "label": "7-point tie-break",
            "target": 7,
            "start": 2,
            "text": "Starts 2–0 up"
          },
          {
            "unit": "championsTiebreak",
            "label": "Match tie-break to 10",
            "target": 10,
            "start": 3,
            "text": "Starts 3–0 up"
          }
        ]
      },
      "played": false,
      "tiebreakMode": 1,
      "tiebreaks": [
        {
          "unit": "tiebreakGame",
          "label": "7-point tie-break",
          "target": 7,
          "starts": [
            0,
            2
          ],
          "display": "0–2"
        },
        {
          "unit": "championsTiebreak",
          "label": "Match tie-break to 10",
          "target": 10,
          "starts": [
            0,
            3
          ],
          "display": "0–3"
        }
      ]
    }
  },
  "Foosball": {
    "schemeKey": "foosball-goals",
    "schemeLabel": "Goals start",
    "start": {
      "homeLabel": "0 goals",
      "awayLabel": "1 goal",
      "homeStart": 0,
      "awayStart": 1,
      "summary": "Alex M. starts each game 1–0 up",
      "isLevel": false,
      "scoreboard": {
        "unit": "game",
        "starts": [
          0,
          1
        ],
        "display": [
          "0",
          "1"
        ]
      },
      "home": {
        "name": "Dana R.",
        "label": "0 goals",
        "sign": 0,
        "players": [],
        "startText": "Each game starts at 0",
        "boardDisplay": "0",
        "tiebreaks": []
      },
      "away": {
        "name": "Alex M.",
        "label": "1 goal",
        "sign": 1,
        "players": [],
        "startText": "Starts each game 1–0 up",
        "boardDisplay": "1",
        "tiebreaks": []
      },
      "played": false,
      "tiebreakMode": 1,
      "tiebreaks": [],
      "entryHint": {
        "unit": "game",
        "starts": [
          0,
          1
        ],
        "allowNegative": false,
        "note": "Enter scores as played, start included."
      }
    }
  },
  "Fencing": {
    "schemeKey": "fencing-touches",
    "schemeLabel": "Touches start",
    "start": {
      "homeLabel": "0 touches",
      "awayLabel": "3 touches",
      "homeStart": 0,
      "awayStart": 3,
      "summary": "Alex M. starts each bout 3–0 up",
      "isLevel": false,
      "scoreboard": {
        "unit": "bout",
        "starts": [
          0,
          3
        ],
        "display": [
          "0",
          "3"
        ]
      },
      "home": {
        "name": "Dana R.",
        "label": "0 touches",
        "sign": 0,
        "players": [],
        "startText": "Each bout starts at 0",
        "boardDisplay": "0",
        "tiebreaks": []
      },
      "away": {
        "name": "Alex M.",
        "label": "3 touches",
        "sign": 1,
        "players": [],
        "startText": "Starts each bout 3–0 up",
        "boardDisplay": "3",
        "tiebreaks": []
      },
      "played": false,
      "tiebreakMode": 1,
      "tiebreaks": []
    }
  },
  "Football": {
    "schemeKey": "football-goals",
    "schemeLabel": "Goals start",
    "start": {
      "homeLabel": "0 goals",
      "awayLabel": "1 goal",
      "homeStart": 0,
      "awayStart": 1,
      "summary": "Athletic starts the match 1–0 up",
      "isLevel": false,
      "scoreboard": {
        "unit": "match",
        "starts": [
          0,
          1
        ],
        "display": [
          "0",
          "1"
        ]
      },
      "home": {
        "name": "Rovers",
        "label": "0 goals",
        "sign": 0,
        "players": [],
        "startText": "The match starts at 0",
        "boardDisplay": "0",
        "tiebreaks": []
      },
      "away": {
        "name": "Athletic",
        "label": "1 goal",
        "sign": 1,
        "players": [],
        "startText": "Starts the match 1–0 up",
        "boardDisplay": "1",
        "tiebreaks": []
      },
      "played": false,
      "tiebreakMode": 1,
      "tiebreaks": [],
      "entryHint": {
        "unit": "match",
        "starts": [
          0,
          1
        ],
        "allowNegative": false,
        "note": "Enter scores as played, start included."
      }
    }
  },
  "Basketball": {
    "schemeKey": "basketball-points",
    "schemeLabel": "Points start",
    "start": {
      "homeLabel": "0 points",
      "awayLabel": "10 points",
      "homeStart": 0,
      "awayStart": 10,
      "summary": "Alex M. starts the match 10–0 up",
      "isLevel": false,
      "scoreboard": {
        "unit": "match",
        "starts": [
          0,
          10
        ],
        "display": [
          "0",
          "10"
        ]
      },
      "home": {
        "name": "Dana R.",
        "label": "0 points",
        "sign": 0,
        "players": [],
        "startText": "The match starts at 0",
        "boardDisplay": "0",
        "tiebreaks": []
      },
      "away": {
        "name": "Alex M.",
        "label": "10 points",
        "sign": 1,
        "players": [],
        "startText": "Starts the match 10–0 up",
        "boardDisplay": "10",
        "tiebreaks": []
      },
      "played": false,
      "tiebreakMode": 1,
      "tiebreaks": [],
      "entryHint": {
        "unit": "match",
        "starts": [
          0,
          10
        ],
        "allowNegative": false,
        "note": "Enter scores as played, start included."
      }
    }
  },
  "Board game": {
    "schemeKey": "boardgame-stones",
    "schemeLabel": "Handicap stones",
    "start": {
      "homeLabel": "0 stones",
      "awayLabel": "3 stones",
      "homeStart": 0,
      "awayStart": 3,
      "summary": "Alex M. starts the game 3–0 up",
      "isLevel": false,
      "scoreboard": {
        "unit": "game",
        "starts": [
          0,
          3
        ],
        "display": [
          "0",
          "3"
        ]
      },
      "home": {
        "name": "Dana R.",
        "label": "0 stones",
        "sign": 0,
        "players": [],
        "startText": "The game starts at 0",
        "boardDisplay": "0",
        "tiebreaks": []
      },
      "away": {
        "name": "Alex M.",
        "label": "3 stones",
        "sign": 1,
        "players": [],
        "startText": "Starts the game 3–0 up",
        "boardDisplay": "3",
        "tiebreaks": []
      },
      "played": false,
      "tiebreakMode": 1,
      "tiebreaks": [],
      "entryHint": {
        "unit": "match",
        "starts": [
          0,
          3
        ],
        "allowNegative": false,
        "note": "Enter scores as played, start included."
      }
    }
  }
};

export const handicapPairsDemo = {
  "homeLabel": "Owe 15",
  "awayLabel": "Receive 15.2",
  "homeStart": -1,
  "awayStart": 1.2,
  "summary": "Dana R. + Alex M. owe 15 and Sam T. + Priya K. receive 15.2 each game",
  "isLevel": false,
  "scoreboard": {
    "unit": "game",
    "starts": [
      -1,
      1
    ],
    "display": [
      "Owe 15",
      "15"
    ],
    "sixGamePattern": [
      "Owe 15–15",
      "Owe 15–30",
      "Owe 15–15",
      "Owe 15–30",
      "Owe 15–15",
      "Owe 15–15"
    ]
  },
  "home": {
    "name": "Dana R. + Alex M.",
    "label": "Owe 15",
    "sign": -1,
    "players": [
      {
        "name": "Dana R.",
        "label": "Owe 30",
        "sign": -1
      },
      {
        "name": "Alex M.",
        "label": "Scratch",
        "sign": 0
      }
    ],
    "startText": "Each game starts at Owe 15",
    "boardDisplay": "Owe 15",
    "tiebreaks": [
      {
        "unit": "tiebreakGame",
        "label": "7-point tie-break",
        "target": 7,
        "start": -2,
        "text": "Starts at −2"
      },
      {
        "unit": "championsTiebreak",
        "label": "Match tie-break to 10",
        "target": 10,
        "start": -3,
        "text": "Starts at −3"
      }
    ]
  },
  "away": {
    "name": "Sam T. + Priya K.",
    "label": "Receive 15.2",
    "sign": 1,
    "players": [
      {
        "name": "Sam T.",
        "label": "Receive 15",
        "sign": 1
      },
      {
        "name": "Priya K.",
        "label": "Receive 15.3",
        "sign": 1
      }
    ],
    "startText": "Each game starts at 15",
    "boardDisplay": "15",
    "patternNote": "At 30 in games 2, 4 of every 6",
    "tiebreaks": [
      {
        "unit": "tiebreakGame",
        "label": "7-point tie-break",
        "target": 7,
        "start": 2,
        "text": "Starts 2–0 up"
      },
      {
        "unit": "championsTiebreak",
        "label": "Match tie-break to 10",
        "target": 10,
        "start": 3,
        "text": "Starts 3–0 up"
      }
    ]
  },
  "played": false,
  "tiebreakMode": 1,
  "tiebreaks": [
    {
      "unit": "tiebreakGame",
      "label": "7-point tie-break",
      "target": 7,
      "starts": [
        -2,
        2
      ],
      "display": "(−2)–2"
    },
    {
      "unit": "championsTiebreak",
      "label": "Match tie-break to 10",
      "target": 10,
      "starts": [
        -3,
        3
      ],
      "display": "(−3)–3"
    }
  ]
};
